export default __webpack_public_path__ + "static/media/redsmin.95ee5ff0.svg";